import { CircularProgress } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";

import { Button } from "../components/Button";

export type ProductBookNowButtonProps = {
    isLoading?: boolean;
    children: string;
} & Omit<ButtonProps, "style" | "color" | "variant" | "children">;

export function ProductBookNowButton({ isLoading, ...props }: ProductBookNowButtonProps) {
    return (
        <Button
            variant="contained"
            size="large"
            color="primary"
            endIcon={isLoading && <CircularProgress color="primary" size="1rem" />}
            disableElevation
            {...props}
        />
    );
}
